import React, { useState, useEffect } from 'react';
import { Picture } from 'models';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

interface Props {
  pictures: Picture[];
  setImageCarouselOpen: (open: boolean) => void;
  setImageCarouselPictures: (pictures: Picture[]) => void;
}

function ImageCarousel(props: Props) {
  const { setImageCarouselOpen, setImageCarouselPictures, pictures } = props;
  const [photoIndex, setPhotoIndex] = useState(0);

  function handelRightClick(event: any) {
    event.preventDefault();
  }

  useEffect(() => {
    document.addEventListener('contextmenu', handelRightClick);
    return () => {
      document.removeEventListener('contextmenu', handelRightClick);
    };
  }, []);

  return (
    <Lightbox
      mainSrc={pictures[photoIndex].distribURL || pictures[photoIndex].url}
      nextSrc={
        pictures[(photoIndex + 1) % pictures.length].distribURL ||
        pictures[(photoIndex + 1) % pictures.length].url
      }
      prevSrc={
        pictures[(photoIndex + pictures.length - 1) % pictures.length].distribURL ||
        pictures[(photoIndex + pictures.length - 1) % pictures.length].url
      }
      onCloseRequest={() => {
        setImageCarouselOpen(false);
        setImageCarouselPictures([]);
      }}
      onMoveNextRequest={() => {
        return setPhotoIndex((photoIndex + 1) % pictures.length);
      }}
      onMovePrevRequest={() => {
        return setPhotoIndex((photoIndex + pictures.length - 1) % pictures.length);
      }}
    />
  );
}

export default ImageCarousel;
